import React from 'react';
import User from '../User';
import { UserTBody } from '../styles/UsersList.styles';

const UsersList = ({
  currentPSAPUsers,
  toggleEditUserModal,
  onCheckBoxChange,
  values,
  arrayHelpers,
}) => {
  return (
    <UserTBody>
      {currentPSAPUsers.map(user => {
        return (
          <User
            key={user.email}
            user={user}
            toggleEditUserModal={toggleEditUserModal}
            onCheckBoxChange={onCheckBoxChange}
            arrayHelpers={arrayHelpers}
            values={values}
          />
        );
      })}
    </UserTBody>
  );
};

export default UsersList;
